import { extendTheme } from "@chakra-ui/react";
import { extend } from "../theme/tailwind.theme";
import { Accordion } from "./components/accordion";
import { Button } from "./components/button";
import { Input } from "./components/input";
import { Menu } from "./components/menu";
import { NumberInput } from "./components/number-input";
import { Select } from "./components/select";
import { Switch } from "./components/switch";
import { Table } from "./components/table";
import { Tabs } from "./components/tabs";
import { Textarea } from "./components/textarea";

export const chakraTheme = extendTheme({
	colors: {
		...extend.colors,
	},
	components: {
		Accordion,
		Input,
		Button,
		Select,
		Switch,
		Menu,
		NumberInput,
		Tabs,
		Table,
		Textarea,
	},
	fonts: {
		heading: "var(--font-montserrat)",
		body: "var(--font-oxygen)",
	},
});
